module.exports = __webpack_public_path__ + "static/media/sec-3-img-4.d7c420d8.png";